<template>
  <el-header style="height: 100%">
    <div class="app-header">
      <div class="header-left">
				<img
          class="logo"
          :src="logoUrl"
					v-if="logoUrl"
        />
        <img
				 v-else
          class="logo"
          src="../../../assets/images/liancheng/logo1.png"
        />
      </div>
      <div class="header-right">
        <ul
          class="ul-tab clearfix"
          :class="{ open: isOpen }"
          @mouseleave="isOpen = false"
        >
          <li
            v-for="(item, index) in treeList"
            :class="{ active: actPath == item.url }"
            class="zh"
            :key="index"
            @click="jump(item)"
          >
            {{ item.name }}
          </li>
          <i class="icon-gengduo" v-show="showMore" @click="changeOpen"></i>
        </ul>

        <div class="min_box">
          <el-popover
            placement="bottom"
            title=""
            width="390"
            trigger="click"
            v-model="visible"
            :visible-arrow="false"
            popper-class="header-poper"
          >
            <div class="tit">
              <i class="icon-baojing"></i>{{ msgcount }}个未读事件通知
            </div>
            <div class="btn_ yidu" v-show="msgcount > 0" @click="allread">
              设置所有为已读
            </div>

            <div class="div" v-for="(item, i) in alarmList" :key="i">
              <div class="iconbox"><span class="icon"></span></div>
              <div class="textbox">
                <p>设备名称：{{ item.deviceName }}</p>
                <p>事件内容：{{ item.alarmMsg }}</p>
                <p>
                  事件发生时间：{{
                    $moment(item.alarmTime).format("YYYY-MM-DD HH:mm:ss")
                  }}
                </p>
              </div>
              <div class="btnbox">
                <span
                  class="btn_"
                  v-show="item.status == 0"
                  @click="check(item.alarmId)"
                  >设为已读</span
                >
                <span class="nobtn" v-show="item.status == 1">已读</span>
              </div>
            </div>
            <div class="btn_ toalarm1" @click="toalarm">查看所有事件>></div>
            <!-- <el-button slot="reference">click 激活</el-button> -->
            <el-badge
              :is-dot="msgcount > 0"
              class="lingdang"
              slot="reference"
              v-show="baojing"
            >
              <i class="el-icon-message-solid" @click="showPopover"></i>
            </el-badge>
          </el-popover>
          <span
            class="user-name"
            style="display: inline-block; margin-top: 25px"
          >
            <el-dropdown trigger="click" @command="handleCommand">
              <span class="el-dropdown-link">
                <span class="employeeZhName">{{
                  $store.state.login.userInfo.employeeZhName
                }}</span>
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  :command="item.url"
                  :key="i"
                  v-for="(item, i) in personList"
                >
                  {{ item.name }}
                </el-dropdown-item>
                <el-dropdown-item command="tuichu">
                  {{ $t("key_tuichu") }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </span>
        </div>
      </div>
    </div>
  </el-header>
</template>
<script>
export default {
  name: "app-header",
  data() {
    return {
      visible: false,

      personList: [
        {
          name: "个人信息",
          url: "/personal-info",
          children: [],
        },
        {
          name: "修改密码",
          url: "/change-password",
          children: [],
        },
      ],
      treeList: [],
      alarmList: [],
      isOpen: false,
      showMore: false,
      actPath: "",
      msgcount: 0,
      menuIdList: [],
      a: 0,
      baojing: false,
      baojingList: [],
			logoUrl:''
    };
  },
  created() {
		this.logoUrl = sessionStorage.logoUrl ||"";
    this.baojing = sessionStorage.baojing;
    this.treeList = JSON.parse(sessionStorage.getItem("treeList"));
    this.baojingList = JSON.parse(sessionStorage.getItem("baojingList"));
    this.menuIdList = JSON.parse(sessionStorage.getItem("menuIdList"));
    this.getMessage();
    this.getList();

    this.useName = this.$store.state.login.userInfo.employeeZhName;

    // 拿到被选中的一级导航path
    let arr = this.$route.path.split("/");
    this.actPath = "/" + arr[1];
  },
  watch: {
    $route(to, from) {
      let arr = to.path.split("/");
      this.actPath = "/" + arr[1];
    },
    // 返回时的监听
    actPath(val, oldVal) {
      if (oldVal == "") {
        return;
      }
      var obj = this.treeList.find((item) => {
        return item.url == val;
      });

      if (obj && obj.id != 2) {
        sessionStorage.setItem("asideList", JSON.stringify(obj.children));
        // console.log(111)
        this.$bus.$emit("change_menuIndex1");
      }
    },
  },
  mounted() {
    if (this.timer) {
      clearInterval(this.timer);
    }
    this.timer = setInterval(() => {
      this.getMessage();
      this.getList();
    }, 60000);
  },
  methods: {
    // 并没有用（不起作用）
    showPopover() {
      if (this.msgcount == 0) {
        this.visible = false;
      }
    },
    check(alarmId) {
      let params = {
        userId: this.$store.state.login.userInfo.userid,
        alarmIdList: [alarmId],
      };
      this.$http
        .put(
          this.$api.getApiAddress(
            "/operationplatformmgn/o/saas/alarm/mark/read",
            "API_ROOT"
          ),
          params
        )
        .then((res) => {
          this.$message({
            message: "设为已读成功",
            type: "success",
          });
          this.getList();
        });
    },
    allread() {
      let params = {
        userId: this.$store.state.login.userInfo.userid,
      };
      this.$http
        .put1(
          this.$api.getApiAddress(
            "/operationplatformmgn/o/saas/alarm/mark/all-read",
            "API_ROOT"
          ),
          params
        )
        .then((res) => {
          this.$message({
            message: "全部设为已读成功",
            type: "success",
          });
          this.getMessage();
          this.getList();
        });
    },

    toalarm() {
      this.$router.push("/alarm-management/alarm-list");
      sessionStorage.setItem("asideList", JSON.stringify(this.baojingList));
      // /  切换侧边栏里信息
      this.$bus.$emit("change_menuIndex1");

      this.visible = false;
    },
    changeOpen() {
      this.isOpen = !this.isOpen;
    },
    getMessage() {
      let params = {
        userId: this.$store.state.login.userInfo.userid,
      };
      this.$http
        .get(
          this.$api.getApiAddress(
            "/operationplatformmgn/o/saas/alarm/total-unread",
            "API_ROOT"
          ),
          params
        )
        .then((res) => {
          this.msgcount = res.data;
        });
    },
    //报警列表
    getList() {
      let params = {
        userId: this.$store.state.login.userInfo.userid,
        // status:0,
        page: 1,
        size: 3,
      };
      this.$http
        .get(
          this.$api.getApiAddress(
            "/operationplatformmgn/o/saas/alarm/list/pc",
            "API_ROOT"
          ),
          params
        )
        .then((res) => {
          this.alarmList = res.data.list;
        });
    },
    jump(item) {
      if (item.id == 2) {
        if (this.menuIdList.includes(3)) {
          // 有全项目驾驶舱

          this.$router.push("/project-overview/cockpit");
        } else if (this.menuIdList.includes(4)) {
          //有gis地图

          this.$router.push("/project-overview/map");
        }
      } else {
        sessionStorage.setItem("asideList", JSON.stringify(item.children));
        // this.$bus.$emit('change_menuIndex1')

        this.$router.push(item.url);
      }
    },
    // 个人中心下的跳转
    handleCommand(command) {
      if (command == "tuichu") {
        this.$store.dispatch("USER_LOGOUT_ACTION");
        sessionStorage.clear();
      } else if (command == "123") {
        return;
      } else {
        this.$router.push(command);
      }
    },
  },
  //实例销毁之前调用。主要解绑一些使用addEventListener监听的事件等
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer); //在Vue实例销毁前，清除我们的定时器
    }
  },
};
</script>
<style lang="less">
.app-header .el-badge {
  margin-top: -14px;
}
.header-poper {
  padding: 0;
  .icon-baojing {
    vertical-align: middle;
    font-size: 21px;
  }
  .tit {
    height: 45px;
    line-height: 45px;
    text-align: center;
    background: linear-gradient(
      90deg,
      rgba(28, 175, 204, 1),
      rgba(120, 238, 204, 1)
    );
    border-radius: 6px;
    font-size: 15px;
    color: #fff;
    margin-bottom: 12px;
  }

  .btn_ {
    color: #0087fe;
    font-size: 14px;
    text-align: right;
    // padding-right:30px;
    cursor: pointer;
  }
  .nobtn {
    color: #9ea2a7;
    font-size: 14px;
    cursor: pointer;
  }
  .toalarm1 {
    text-align: center;
    margin: 3px 0 15px 0;
  }
  .yidu {
    padding-right: 22px;
  }
  .div {
    height: 60px;
    padding: 12px 0 0 20px;
    margin-bottom: 20px;
  }
  .iconbox {
    float: left;
    width: 14px;
    height: 60px;
    padding-top: 5px;
  }
  .icon {
    display: block;
    width: 12px;
    height: 12px;
    background: #1db0cc;
    border-radius: 14px;
  }
  .textbox {
    width: 260px;
    float: left;
    padding-left: 10px;
    p {
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
  .btnbox {
    float: left;
    margin-left: 30px;
    height: 60px;
    line-height: 60px;
    text-align: right;
  }
}
</style>


<style lang="less" scoped>
.app-header {
  height: 100%;
  position: relative;
  z-index: 999;
  padding: 0;
  background-position: 50%;
  display: flex;
  display: -webkit-flex;
  .header-left {
    width: 244px;
    padding-top: 14px;
    box-sizing: border-box;
    background: #0151ac;
    position: relative;

    img {
      width: 120px;
      height: 30px;
      top: 21px;
      left: 41px;
      position: absolute;
    }
  }
  .header-right {
    flex-grow: 1;
    box-sizing: border-box;
    .ul-tab {
      padding-left: 5px;
      height: 70px;
      position: relative;
      box-sizing: border-box;
      width: calc(100% - 130px);
      overflow: hidden;
      li {
        // display: inline-block;
        float: left;
        margin: 0 19px;
        max-width: 110px;
        color: #2e3640;
        cursor: pointer;
        font-size: 16px;
        box-sizing: border-box;
        height: 70px;
        text-align: center;
        line-height: 1.2;
        padding-top: 11px;
        border-top: 4px solid transparent;
      }
      li.zh {
        padding-top: 0;
        font-size: 16px;
        line-height: 66px;
        // width:80px;
      }
      li.active {
        // border-bottom:4px solid #87BDFF;
        color: #0087fe;
      }
      .icon-gengduo {
        font-size: 22px;
        position: absolute;
        top: 25px;
        right: 0px;
        color: #abbdda;
      }
    }
    .open {
      height: auto;
      background: #0a3c89;
    }
    .min_box {
      position: absolute;
      right: 0;
      top: 0;
      .el-icon-message-solid {
        font-size: 18px;
        vertical-align: top;
      }
      .lingdang {
        margin-right: 6px;
        cursor: pointer;
      }
    }
    .employeeZhName {
      max-width: 80px;
      display: inline-block;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      color: #434343;
      height: 20px;
    }
    .el-icon--right {
      font-size: 18px;
      color: #434343;
      margin-right: 15px;
      cursor: pointer;
    }
    .el-dropdown-link {
      cursor: pointer;
      color: #434343;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/views/layout/app-header1.vue